import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import Table from "react-bootstrap/Table";
import Moment from "react-moment";
import cogoToast from "@successtar/cogo-toast";

function AutoPolicySummary({ autoData, colSize, admin }) {
  const [formData, setFormData] = useState({
    editActivated: false,
    showInfo: false,
    id: "",
    carrier: "",
    policyNumber: "",
    effectiveDate: "",
    BI: "",
    PD: "",
    UM: "",
    UIM: "",
    TORT: "",
    premium: "",
    vehicles: null,
    drivers: null
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      id: autoData._id,
      carrier: autoData.carrier,
      policyNumber: autoData.policyNumber,
      effectiveDate: autoData.effectiveDate,
      BI: autoData.BI,
      PD: autoData.PD,
      UM: autoData.UM,
      UIM: autoData.UIM,
      TORT: autoData.TORT,
      premium: autoData.premium
    }));

    API.findVehicles(autoData._id)
      .then((res) => {
        setFormData((prev) => ({
          ...prev,
          vehicles: res.data
        }));
      })
      .catch((err) => console.log(err));

    API.findDrivers(autoData._id)
      .then((res) => {
        setFormData((prev) => ({
          ...prev,
          drivers: res.data
        }));
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const activateEdit = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      editActivated: !prev.editActivated
    }));
  };

  const saveEdits = (e) => {
    e.preventDefault();
    API.updateAutoPolicy(autoData._id, {
      carrier: formData.carrier,
      policyNumber: formData.policyNumber,
      BI: formData.BI,
      PD: formData.PD,
      UM: formData.UM,
      UIM: formData.UIM,
      TORT: formData.TORT,
      premium: parseInt(formData.premium)
    })
      .then((_res) => {
        alert("You've updated this policy!");
      })
      .catch((_err) => alert("The edit did not go through!"));
  };

  const softdeleteVehicle = (id) => {
    API.softDeleteVehicle(id)
      .then((_res) => {
        alert("You've deleted this vehicle");
      })
      .catch((_err) => alert("The deletion did not go through"));
  };

  const softdeleteDriver = (id) => {
    API.softDeleteDriver(id)
      .then((_res) => {
        alert("You've deleted this driver");
      })
      .catch((_err) => alert("The deletion did not go through"));
  };

  const softDeleteAuto = (id) => {
    API.softDeleteAuto(id)
      .then((_res) => {
        alert("You've deleted this vehicle policy");
      })
      .catch((_err) => alert("The deletion did not go through"));
  };

  const showInfo = () => {
    setFormData((prev) => ({
      ...prev,
      showInfo: !prev.showInfo
    }));
  };

  const copyText = (event, data) => {
    event.preventDefault();
    if (data !== undefined) {
      navigator.clipboard.writeText(data);
      cogoToast.success("Copied: " + data);
    } else {
      cogoToast.error("Couldn't copy data");
    }
  };

  return (
    <div className={colSize}>
      {autoData.policyActive ? (
        <div className="card" style={{ overflow: "auto" }}>
          <div className="card-header" style={{ color: "black" }}>
            <h5>
              <strong>{autoData.carrier} Auto</strong>
            </h5>
            <h6>
              <strong>Policy #: {autoData.policyNumber}</strong>
            </h6>
            <button className="btn-success btn" onClick={showInfo}>
              Show / Hide
            </button>
            {admin ? (
              <button className="btn-warning btn" onClick={activateEdit}>
                Edit
              </button>
            ) : null}
            {admin ? (
              <button className="btn-danger btn" onClick={() => softDeleteAuto(autoData._id)}>
                Delete
              </button>
            ) : null}
          </div>
          {formData.editActivated ? (
            <>
              <div className="card-body" style={{ backgroundColor: "black" }}>
                <Table striped bordered hover responsive>
                  <tbody>
                    <tr>
                      <th>
                        <h4>
                          <strong>
                            <u></u>
                          </strong>
                        </h4>
                      </th>
                      <th>
                        <strong></strong>
                      </th>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Carrier</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.carrier}
                          name="carrier"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Policy Number</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.policyNumber}
                          name="policyNumber"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Annual Premium</td>
                      <td>
                        <input
                          type="number"
                          onChange={handleInputChange}
                          value={formData.premium}
                          name="premium"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Effective Date</td>
                      <td>
                        <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
                          {autoData.effectiveDate}
                        </Moment>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <Table striped bordered hover responsive>
                  <tbody>
                    <tr style={{ backgroundColor: "white" }}>
                      <th>Coverage</th>
                      <th>Amount</th>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Bodily Injury</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.BI}
                          name="BI"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Property Damage</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.PD}
                          name="PD"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Uninsured Motorist</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.UM}
                          name="UM"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Underinsured Motorist</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.UIM}
                          name="UIM"
                        />
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: "white" }}>
                      <td>Tort Option</td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.TORT}
                          name="TORT"
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <button
                  style={{ textAlign: "center" }}
                  className="btn btn-success"
                  onClick={saveEdits}
                >
                  Save Edits
                </button>
              </div>
            </>
          ) : (
            <div className="card-body" style={{ backgroundColor: "white" }}>
              {formData.showInfo ? (
                <>
                  <Table striped bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>
                          <strong></strong>
                        </th>
                        <th>
                          <strong></strong>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <strong>Carrier</strong>
                        </td>
                        <td>{autoData.carrier}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Policy Number</strong>
                        </td>
                        <td>
                          {autoData.policyNumber}{" "}
                          <i
                            className="fa-solid fa-copy"
                            onClick={(e) => {
                              copyText(e, autoData.policyNumber);
                            }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Premium</strong>
                        </td>
                        <td>${autoData.premium}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Effective Date</strong>
                        </td>
                        <td>
                          <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
                            {autoData.effectiveDate}
                          </Moment>
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  <Table striped bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>
                          <strong>Coverage</strong>
                        </th>
                        <th>
                          <strong>Amount</strong>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <strong>Bodily Injury</strong>
                        </td>
                        <td>${autoData.BI}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Property Damage</strong>
                        </td>
                        <td>${autoData.PD}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Uninsured Motorist</strong>
                        </td>
                        <td>${autoData.UM}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Underinsured Motorist</strong>
                        </td>
                        <td>${autoData.UIM}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Tort Option</strong>
                        </td>
                        <td>{autoData.TORT}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <Table striped bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>
                          <strong>Type</strong>
                        </th>
                        <th>
                          <strong>Description</strong>
                        </th>
                        {admin ? <th>Action</th> : null}
                      </tr>

                      {formData.vehicles ? (
                        <>
                          {formData.vehicles.map((vehicle) => (
                            <tr key={vehicle._id}>
                              {vehicle.activeOnPolicy ? (
                                <>
                                  <td>
                                    <strong>Vechicle</strong>
                                  </td>
                                  <td>
                                    {vehicle.year + " " + vehicle.make + " " + vehicle.model}{" "}
                                  </td>
                                  <td>
                                    <p>Comprehensive: {vehicle.compDed}</p>
                                    <p> Collision: {vehicle.collDed}</p>
                                    <p> Glass: {vehicle.glassDed}</p>
                                  </td>
                                  <td>
                                    <a href={vehicle.IDCard}>ID Card</a>
                                  </td>
                                  {admin ? (
                                    <td>
                                      <button
                                        className="btn btn-danger"
                                        onClick={() => softdeleteVehicle(vehicle._id)}
                                      >
                                        Delete
                                      </button>
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                </>
                              ) : null}
                            </tr>
                          ))}
                        </>
                      ) : null}

                      {formData.drivers ? (
                        <>
                          {formData.drivers.map((driver) => (
                            <tr key={driver._id}>
                              {driver.active ? (
                                <>
                                  <td>
                                    <strong>Driver</strong>
                                  </td>
                                  <td>{driver.firstName + " " + driver.lastName}</td>

                                  {admin ? (
                                    <td>
                                      <button
                                        className="btn btn-danger"
                                        onClick={() => softdeleteDriver(driver._id)}
                                      >
                                        Delete
                                      </button>
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                </>
                              ) : null}
                            </tr>
                          ))}
                        </>
                      ) : null}
                    </tbody>
                  </Table>
                </>
              ) : null}
            </div>
          )}
        </div>
      ) : null}
      <br />
    </div>
  );
}

export default AutoPolicySummary;
